export const hasErrorField = <T extends object>(obj: T): obj is T & { error: unknown } =>
	obj && 'error' in obj;
